import { GAME_ASSET_SLUG } from "@/config/game";
import {
  PlayerCardWithMetaRating,
  PlayerCardWithMetaRatingSkeleton,
} from "@/design-system/PlayerCard/PlayerCard";
import {
  fetchFavoriteClubPlayers,
  frontPageSelector,
} from "@/redux/frontPage/frontPageSlice";
import { AppDispatch } from "@/redux/store";
import { BREAKPOINTS } from "@/settings";
import { ClubData } from "@repo/shared/api";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

type Props = {
  club: ClubData | null;
};

export const ClubStatsPanel = ({ club }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const assetsBaseUrl = import.meta.env.VITE_APP_ASSETS_BASE_URL;
  const name = club?.name ?? "—";
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);

  let numberOfPlayersToShow = 3;
  if (isTouchDevice) {
    numberOfPlayersToShow = 2;
  }
  if (isMobile) {
    numberOfPlayersToShow = 1;
  }

  useEffect(() => {
    if (club?.id) {
      dispatch(
        fetchFavoriteClubPlayers({ clubId: club.id, activeTab: "players" }),
      );
    }
  }, [club?.id]);

  const { favoriteClubPlayers, favoriteClubPlayersStatus } =
    useSelector(frontPageSelector);

  return (
    <div className="flex-1 rounded-[20px] border border-neutral-700 bg-neutral-900 p-4 mobile:p-6 flex flex-col gap-4">
      <div className="flex items-center justify-center gap-4">
        {club && (
          <img
            src={`${assetsBaseUrl}/${GAME_ASSET_SLUG}/clubs/${club.id}.png?scale=50`}
            alt={club.name}
            className="size-[31px] object-contain"
          />
        )}
        <span className="text-2xl font-bold uppercase text-neutral-300">
          {name}
        </span>
      </div>

      <div className="h-px w-full bg-gradient-to-r from-transparent via-amber-500/40 to-transparent" />

      <div className="flex flex-1 items-center justify-center gap-4">
        {favoriteClubPlayersStatus === "pending"
          ? Array.from({ length: numberOfPlayersToShow }).map((_, index) => (
              <PlayerCardWithMetaRatingSkeleton key={index} scale={0.8} />
            ))
          : favoriteClubPlayers
              .slice(0, numberOfPlayersToShow)
              .map((player) => (
                <PlayerCardWithMetaRating
                  key={player.resourceId}
                  scale={0.8}
                  player={player}
                />
              ))}
      </div>
    </div>
  );
};
